import { gql } from '@apollo/client';
import { NEW_COMMUNICATION } from '../fragments/communications';

export const GET_COMMUNICATION_BY_ID = gql`
  query GetCommunicationById($id: ID!) {
    communication(id: $id) { ...NewCommunication }
  }
  ${NEW_COMMUNICATION}
`;

// Warm-up de caché para el detalle de OT/campaña e informes: resuelve N
// Communications en UNA query servidor (backend `communicationsByIds`,
// tenant-scoped, máx 200 ids, orden de salida NO garantizado — irrelevante:
// solo interesa poblar la caché normalizada). Usa EXACTAMENTE el fragment
// NewCommunication (el mismo de GET_COMMUNICATION_BY_ID) para que los
// `client.query(GET_COMMUNICATION_BY_ID, cache-first)` per-row den hit vía
// el redirect `Query.communication → toReference` de policies.ts.
// A diferencia de Action (caveat isBasic), el type Communication NO tiene
// ningún @ResolveField en el backend (verificado 2026-07-21) y el select del
// batch (COMMUNICATION_LIST_SELECT) es superset de los 22 campos del
// fragment — se puede pedir el fragment completo sin excepciones.
export const GET_COMMUNICATIONS_BY_IDS = gql`
  query CommunicationsByIds($ids: [ID!]!) {
    communicationsByIds(ids: $ids) { ...NewCommunication }
  }
  ${NEW_COMMUNICATION}
`;

export const FETCH_COMMUNICATIONS = gql`
  query FetchCommunications($input: FilterCommunicationList!) {
    communications(input: $input) {
      communications { ...NewCommunication }
      totalCount
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
    }
  }
  ${NEW_COMMUNICATION}
`;

export const GET_INTERLOCUTOR_GROUP_BY_ID = gql`
  query GetInterlocutorGroupById($id: ID!) {
    interlocutorGroup(id: $id) {
      id
      name
    }
  }
`;

export const GET_MEDIA_OF_COMMUNICATION_BY_ID = gql`
  query GetMediaOfCommunicationById($id: ID!) {
    mediaOfCommunication(id: $id) {
      id
      name
    }
  }
`;
